import { useState } from "react";
import { Info, ChevronDown, ExternalLink } from "lucide-react";

export const ReformExplainer = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/70 p-4" data-testid="reform-explainer">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between text-left"
        data-testid="reform-explainer-toggle"
      >
        <span className="flex items-center gap-2 font-medium text-amber-900">
          <Info className="w-4 h-4" />
          What changed: 2026-27 Budget tax reforms
        </span>
        <ChevronDown className={`w-4 h-4 text-amber-700 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-3 text-sm text-amber-900/90 space-y-2">
          <p>
            The Federal Budget (budget night 12 May 2026) changes how property investments are taxed,
            <strong> effective 1 July 2027</strong>:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Negative gearing</strong> becomes limited to <strong>new builds</strong>. Properties held before
              budget night are grandfathered (unchanged). Established homes bought after budget night can only offset
              rental losses against residential property income (carried forward) — not wages/other income.
            </li>
            <li>
              <strong>Capital Gains Tax</strong>: the 50% discount is replaced by taxing the <strong>real
              (inflation-adjusted) gain</strong> with a minimum 30% tax. New builds may still choose the 50% discount.
            </li>
          </ul>
          <p className="text-xs text-amber-800">
            Figures in this app are general estimates only and not tax advice.
          </p>
          <a
            href="https://budget.gov.au/content/04-tax-reform.htm"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-[#547d91] font-medium hover:underline"
            data-testid="reform-source-link"
          >
            Read the official budget source <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>
      )}
    </div>
  );
};
